// 5-tab bottom navigation: Home / Closet / Try-on (center FAB) / Looks / Me
// Per docs/design-spec.md §3 (bottom tab bar) + §4 (screen layouts).
//
// Visual rules:
// - Active tabs: full opacity, font-weight 600
// - Inactive tabs: opacity 0.55
// - Center "Try-on" item is a 46×46 purple tile with sparkle icon and
//   soft purple glow. Lifts -6px out of the bar.

const STROKE = 1.6;

function HomeIcon() {
  return (
    <svg viewBox="0 0 22 22" width="22" height="22" fill="none" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9.5 11 3l8 6.5" />
      <path d="M5 9v9h12V9" />
    </svg>
  );
}
function ClosetIcon() {
  return (
    <svg viewBox="0 0 22 22" width="22" height="22" fill="none" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="16" height="15" rx="1.5" />
      <path d="M11 4v15M7 8h.01M15 8h.01" />
    </svg>
  );
}
function LooksIcon() {
  return (
    <svg viewBox="0 0 22 22" width="22" height="22" fill="none" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 18.5s-7-4.2-7-9.2A4.3 4.3 0 0 1 11 6.2 4.3 4.3 0 0 1 18 9.3c0 5-7 9.2-7 9.2Z" />
    </svg>
  );
}
function MeIcon() {
  return (
    <svg viewBox="0 0 22 22" width="22" height="22" fill="none" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="8" r="3.4" />
      <path d="M4 19c1-3 3.5-4.5 7-4.5s6 1.5 7 4.5" />
    </svg>
  );
}
function SparkleIcon() {
  return (
    <svg viewBox="0 0 22 22" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4v4M11 14v4M4 11h4M14 11h4M6 6l2.5 2.5M13.5 13.5 16 16M6 16l2.5-2.5M13.5 8.5 16 6" />
    </svg>
  );
}

const ITEMS = [
  { key: 'home',   label: 'Home',   Icon: HomeIcon },
  { key: 'closet', label: 'Closet', Icon: ClosetIcon },
  { key: 'tryon',  label: 'Try-on', Icon: SparkleIcon, fab: true },
  { key: 'looks',  label: 'Looks',  Icon: LooksIcon },
  { key: 'me',     label: 'Me',     Icon: MeIcon },
];

export default function BottomNav({ screen, onNav }) {
  return (
    <nav className="bottom-nav">
      {ITEMS.map(({ key, label, Icon, fab }) => {
        const active = screen === key;
        if (fab) {
          return (
            <button
              key={key}
              className={`nav-item fab${active ? ' active' : ''}`}
              onClick={() => onNav(key)}
              aria-label={label}
              type="button"
            >
              <span className="fab-tile">
                <Icon />
              </span>
              <span>{label}</span>
            </button>
          );
        }
        return (
          <button
            key={key}
            className={`nav-item${active ? ' active' : ''}`}
            onClick={() => onNav(key)}
            aria-label={label}
            type="button"
          >
            <Icon />
            {label}
          </button>
        );
      })}
    </nav>
  );
}
